import React, { useEffect, useState } from 'react';
import { useAuth } from './AuthContext';
import MainLayOut from '../../layout/MainLayOut';
// import API_BASE_URL from '../../global/apiConfig';
import { useGlobal } from '../../global/GlobalContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import {
  FiMail,
  FiLock,
  FiEye,
  FiEyeOff,
  FiAlertCircle,
  FiMessageCircle,
  FiCheckCircle,
} from 'react-icons/fi';
// import GoogleLoginButton from './GoogleLoginButton';
import axios from 'axios';
import { toast } from 'react-toastify';

const SUPPORT_EMAIL = 'support@mpivirginplastic.com';
const SUPPORT_WHATSAPP = 'https://wa.me/+919733228888';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isPasswordChange, setIsPasswordChange] = useState(false);
  const [otpSend, setOtpSend] = useState(false);
  // const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); // Loading state
  // const [otpLoading, setOtpLoading] = useState(false);
  const { setToken } = useAuth();
  const [varify, setVarify] = useState(false);
  const { mergeLocalCartWithServer } = useGlobal();
  const [showPassword, setShowPassword] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const redirectTo = '/myaccount';
  // console.log('location', location);
  // console.log('redirectTo', redirectTo);

  // Account-deactivation errors get an extra "contact support" call-to-action
  // below the alert instead of just a bare sentence.
  const isAccountInactiveError = !!error && /not active|deactivat/i.test(error);

  useEffect(() => {
    const uservarified = localStorage.getItem('uservarified');
    if (uservarified && uservarified === 'null') return;
    if (localStorage.getItem('userToken') && localStorage.getItem('uservarified')) {
      navigate(redirectTo, { state: location.state });
    }
  }, [redirectTo])

  useEffect(() => {
    const loginMessage = localStorage.getItem('loginMessage');
    if (loginMessage) {
      setError(loginMessage);
      localStorage.removeItem('loginMessage');
    }
  }, [])

  const loginUser = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/v1/webuser/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username: email, password }),
      });

      const data = await response.json();
      if (!data.status) {
        setError(data.message || data.error_message || 'Login failed');
        return;
      }
      // console.log('data', data);
      if (data.user_data.email && (data.user_data.email_verified_at === null)) {
        setToken(data.user_token);
        setVarify(true);
        return;
      }

      if (data.status) {
        console.log('data', data);
        if (
          data.user_data.email_verified_at !== null &&
          (!localStorage.getItem('uservarified') || localStorage.getItem('uservarified') === "null")
        ) {
          localStorage.setItem('uservarified', data.user_data.email_verified_at);
        }

        // return;
        setToken(data.user_token);
        localStorage.setItem('username', data.user_data.name);
        localStorage.setItem('useremail', data.user_data.email);
        localStorage.setItem('role', data.user_data?.role);
        if (data.user_data?.role === 'distributor') {
          sessionStorage.clear();
        }
        await mergeLocalCartWithServer(data.user_token);

        navigate(redirectTo, { state: location.state });
        window.location.reload();
      } else {
        setError(data.message || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred while logging in.');
    } finally {
      setLoading(false);
    }
  };

  const sendOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/v1/forgot-password`, {
        "email": email
      });

      const data = response.data;
      // console.log('response', response);
      console.log('forgot-password', data);
      if (data.status) {
        // console.log('response', response);
        setOtpSend(true);
      } else {
        setError(data.response || 'Login failed');
      }
    } catch (error) {
      setError('An error occurred while sending OTP.');
    } finally {
      setLoading(false);
    }
  };

  const resendHandler = async () => {
    setLoading(true);
    setSuccess(null);
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/resend_email_verification`, {
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${localStorage.getItem('userToken')}`
        },
      });

      // console.log("API Response:", response.data);
      // return;
      if (response.data.status) {
        setSuccess("Email sent successfully");
      } else {
        toast.error(response.data.message, { position: "top-center" });
      }
    }
    catch (error) {
      console.error("Error:", error.response ? error.response.data : error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <MainLayOut>
      <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4 py-12">
        {varify ? (
          <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
            <div className="w-12 h-12 rounded-full bg-amber-50 flex items-center justify-center mb-4">
              <FiMail className="text-amber-500" size={22} />
            </div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">Verify your email</h2>
            <p className="text-sm text-gray-600 mb-4">
              We've sent a verification link to your email address. Please check your inbox
              (and spam folder) and click the link to continue.
            </p>
            <p className="text-sm text-gray-600">
              Didn't receive the email?{' '}
              {loading ? (
                <span className="text-gray-500">Please wait...</span>
              ) : success ? (
                <span className="inline-flex items-center gap-1 text-green-600 font-medium">
                  <FiCheckCircle size={14} /> Verification link sent
                </span>
              ) : (
                <button
                  onClick={resendHandler}
                  className="text-brand-600 font-medium underline hover:text-brand-700"
                >
                  Resend verification link
                </button>
              )}
            </p>
          </div>
        ) : (
          <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
            <div className="text-center mb-6">
              <h1 className="text-xl font-semibold text-gray-900">Welcome back</h1>
              <p className="text-sm text-gray-500 mt-1">Login to your MPI account</p>
            </div>

            {/* <div className='flex items-center justify-center gap-4 my-4'>
            <GoogleLoginButton />
          </div> */}

            <div className="flex items-center gap-2 mb-6 bg-gray-100 rounded-xl p-1">
              <Link
                to={'../login'}
                className="flex-1 text-center py-2 rounded-lg text-sm font-medium bg-brand-600 text-white shadow-sm"
              >
                Login
              </Link>
              <Link
                to={`../register`}
                className="flex-1 text-center py-2 rounded-lg text-sm font-medium text-gray-600 hover:text-gray-900"
              >
                Sign up
              </Link>
            </div>

            {error && (
              <div className="mb-5 rounded-xl border border-red-100 bg-red-50 p-4">
                <div className="flex items-start gap-2.5">
                  <FiAlertCircle className="text-red-500 mt-0.5 shrink-0" size={18} />
                  <p className="text-sm text-red-700">{error}</p>
                </div>
                {isAccountInactiveError && (
                  <div className="mt-3 pt-3 border-t border-red-100 flex flex-col gap-1.5">
                    <p className="text-xs text-red-600">
                      If you believe this is a mistake, our support team can help you regain access.
                    </p>
                    <div className="flex flex-wrap gap-3 text-xs font-medium">
                      <a
                        href={`mailto:${SUPPORT_EMAIL}`}
                        className="inline-flex items-center gap-1.5 text-brand-600 hover:underline"
                      >
                        <FiMail size={13} /> {SUPPORT_EMAIL}
                      </a>
                      <a
                        href={SUPPORT_WHATSAPP}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1.5 text-brand-600 hover:underline"
                      >
                        <FiMessageCircle size={13} /> Chat on WhatsApp
                      </a>
                    </div>
                  </div>
                )}
              </div>
            )}

            {isPasswordChange ? (
              <>
                <form onSubmit={sendOtp} className="space-y-4">
                  <div>
                    <label htmlFor="reset_email" className="block text-sm font-medium text-gray-700 mb-1.5">
                      Registered email
                    </label>
                    <div className="relative">
                      <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                      <input
                        id="reset_email"
                        name="user_email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-600/20 focus:border-brand-600"
                        placeholder="Enter your registered email"
                      />
                    </div>
                    {otpSend && (
                      <p className="text-xs text-green-600 mt-2">A reset link has been sent to your email.</p>
                    )}
                  </div>

                  <button
                    className={`w-full py-2.5 rounded-xl text-white font-medium transition-colors ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-brand-600 hover:bg-brand-700'
                      }`}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <span className="inline-flex items-center justify-center gap-2">
                        <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                        Sending...
                      </span>
                    ) : otpSend ? (
                      'Link sent successfully'
                    ) : (
                      'Send reset link'
                    )}
                  </button>
                </form>
                <div className="mt-4 text-center">
                  <button onClick={() => setIsPasswordChange(false)} className="text-sm text-brand-600 hover:underline">
                    Back to login
                  </button>
                </div>
              </>
            ) : (
              <>
                <form onSubmit={loginUser} className="space-y-4">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1.5">
                      Email / Phone number
                    </label>
                    <div className="relative">
                      <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                      <input
                        id="email"
                        type="text"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full pl-10 pr-3 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-600/20 focus:border-brand-600"
                        placeholder="Enter your email / phone number"
                      />
                    </div>
                  </div>
                  <div>
                    <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1.5">
                      Password
                    </label>
                    <div className="relative">
                      <FiLock className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={16} />
                      <input
                        id="password"
                        type={showPassword ? "text" : "password"}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full pl-10 pr-10 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-brand-600/20 focus:border-brand-600"
                        placeholder="Enter your password"
                      />
                      <button
                        type="button"
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff size={16} /> : <FiEye size={16} />}
                      </button>
                    </div>
                  </div>
                  <button
                    className={`w-full py-2.5 rounded-xl text-white font-medium transition-colors ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-brand-600 hover:bg-brand-700'
                      }`}
                    type="submit"
                    disabled={loading}
                  >
                    {loading ? (
                      <span className="inline-flex items-center justify-center gap-2">
                        <span className="w-4 h-4 border-2 border-white/40 border-t-white rounded-full animate-spin" />
                        Logging in...
                      </span>
                    ) : (
                      'Proceed'
                    )}
                  </button>
                </form>
                <div className="mt-4 text-center">
                  <button onClick={() => setIsPasswordChange(true)} className="text-sm text-brand-600 hover:underline">
                    Forgot your password?
                  </button>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </MainLayOut>
  );
};

export default Login;
